import { getController, root } from '../../../../store/constants';
import { Dispatch, ThunkAction } from '../../../../types/actions';
import {
    SegmentBoardEvent,
    SegmentBoardSettingsSourceValue
} from '../../../../middlewares/segment/trackEntities/boardEvents';
import { segmentTrackAction } from '../../../../middlewares/segment';
import { IGetState } from '../../../../types/types';

export const openBoardSettings = (
    tab: string,
    sourceValue: SegmentBoardSettingsSourceValue,
    trigger: boolean = true,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (getController().blockerHelper.showSnoozeBlockerForDemo()) return;
        if (!tab) tab = '';
        if (!root.App.controller.isRelatedPanelNotOpened()) return;
        if (tab) {
            tab = '/' + tab.toLowerCase(); // к низкому реестру, чтобы не кидалось в глаза в url
        }
        root.App.router.navigate(root.App.router.getUrl('edit' + tab), {trigger});
        if (sourceValue) {
            dispatch(segmentTrackAction(SegmentBoardEvent.BOARD_DETAILS, {
                name: 'source',
                value: sourceValue
            }));
        }
    };
    return action;
}
